export default __webpack_public_path__ + "static/6734-e6f8130673a9639553bb5c85a23d2cdf.jpg";